import React from "react";

const Icon = ({ index }: { index: number }) => {
  const iconPath = localStorage.getItem("icon-path") || "icon_foods";
  return <img src={require(`@/assets/${iconPath}/${index}.png`)} alt="" />;
};

export default Icon;
